import image1 from '../../../../assets/Carousel_3_1.png';
import image2 from '../../../../assets/Carousel_3_2.png';
import image3 from '../../../../assets/Carousel_3_3.png';

export const slidesStories: { image: string, title: string, info: string }[] = [
  {
    image: image1,
    title: 'Planet-Friendly Activewear',
    info: 'Run Collection is made with sustainable materials that can stand up to your workout.',
  },
  {
    image: image2,
    title: 'adidas and Allbirds',
    info: 'Learn more about FUTURECRAFT.FOOTPRINT, our collaborative shoe coming soon.',
  },
  {
    image: image3,
    title: 'How much did your outfit cost the planet?',
    info: 'Now any brand can use our Carbon Footprint tools to label their emissions.',
  },
  {
    image: image1,
    title: 'Planet-Friendly Activewear',
    info: 'Run Collection is made with sustainable materials that can stand up to your workout.',
  },
  {
    image: image2,
    title: 'adidas and Allbirds',
    info: 'Learn more about FUTURECRAFT.FOOTPRINT, our collaborative shoe coming soon.',
  },
  {
    image: image3,
    title: 'How much did your outfit cost the planet?',
    info: 'Now any brand can use our Carbon Footprint tools to label their emissions.',
  },
];
